import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/platform/messages";
import { camelizeKeys } from "lib/helpers";

function* getModuleDetail(action) {
  const { success, data, error } = yield* makeRequest.get("/enterprise_modules/show_by_slug", action.payload);

  if (success && data) {
    yield put(actions.setModuleDetail(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.GET_MODULE_DETAIL_ERROR,
    });
  }

  return null;
}

export default getModuleDetail;
